/*
 *###############################################################################
 *Module Name                   : VoucherBarcodePrintController.js                #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Thursday, January 12th 2022, 9:53:19 am        #
 *Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
const getVoucherGRNSearch = async (LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: { 
      "Authorization": `Bearer ${authToken}`
   },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGRN/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherBook = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: { 
      "Authorization": `Bearer ${authToken}`
   },
    redirect: "follow",
  }

  await fetch(`${ApiURL}VoucherTRO/GetBookListPrint`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getVoucherNumber = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: { 
      "Authorization": `Bearer ${authToken}`
   },
    redirect: "follow",
  }

  await fetch(`${ApiURL}VoucherTRO/GetVoucherNumberPrint`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherPrintSummary = async (
  strVoucherFrom,
  strVoucherTo,
  strBookFrom,
  strBookTo,
  strGrnNo
) => {
  if (strVoucherFrom == "") {
    strVoucherFrom='0';
  }
  if (strVoucherTo == "") {
    strVoucherTo='0';
  }
  if (strBookFrom == "") {
    strBookFrom='0';
  }
  if (strBookTo == "") {
    strBookTo='0';
  }
  if (strGrnNo == "") {
    strGrnNo='0';
  }
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: { 
      "Authorization": `Bearer ${authToken}`
   },
    redirect: "follow",
  }

  await fetch(
    `${ApiURL}VoucherTRO/LoadVoucherDetails/${strGrnNo}/${strVoucherFrom}/${strVoucherTo}/${strBookFrom}/${strBookTo}`,
    requestOptions
  )
    .then(response => response.json())
    .then(result => {
      data = result.data 
    })
    .catch(error => console.log("error", error))
  return data
}
// Voucher print save method
const setVoucherSave = async (
  LocationCode,
  LogUserType,
  VoucherPoDet
   
) => {
  var myHeaders = new Headers()
  const authToken = localStorage.getItem("authToken")
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);
  
  var raw = JSON.stringify({
    strCreateBy: LogUserType,
    strFromLocCode: LocationCode,
    VOUCHERPRINT:VoucherPoDet
     
  })
 
  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }
  var data = [];
  await fetch(`${ApiURL}VoucherTRO/SaveVoucherPrint`, requestOptions)
      .then(response => data = response)
      .catch(error => console.log('error', error))
  return data;
}

export {
  getVoucherGRNSearch,
  getVoucherBook,
  getVoucherNumber,
  getVoucherPrintSummary,
  setVoucherSave

}
